import { render, staticRenderFns } from "./MStoreSimpleTable.vue?vue&type=template&id=6810ee57&scoped=true&"
import script from "./MStoreSimpleTable.vue?vue&type=script&lang=ts&"
export * from "./MStoreSimpleTable.vue?vue&type=script&lang=ts&"
import style0 from "./MStoreSimpleTable.vue?vue&type=style&index=0&id=6810ee57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6810ee57",
  null
  
)

export default component.exports